import React from 'react';
import { LayoutGroup, motion } from 'framer-motion';
import { Timer, Check, UserCheck } from 'lucide-react';
import { useStepCycle } from '../../hooks/useStepCycle';
import { EASE_IN_OUT, EASE_OUT } from '../../utils/motion';
const columns = ['Sprint-Backlog', 'In Entwicklung', 'Review & Test'];
const cards = ['Benutzer & Rollen', 'Auftragsübersicht', 'Lagerbestand'];
const phaseLabels = ['Sprint-Start', 'Woche 1', 'Woche 2', 'Review'];
export function SprintIllustration() {
  const phase = useStepCycle(4, 1500);
  const column = Math.min(phase, 2);
  const tested = phase === 3;
  return <div className="absolute inset-0 p-6 xl:p-8 flex flex-col gap-4" data-id="element-125" data-mp="28i9s69d3ol5z">
      <div className="bg-white rounded-2xl shadow-sm px-5 py-4" data-id="element-126" data-mp="28fdumm55zyi2">
        <div className="flex items-center justify-between text-sm mb-2" data-id="element-127" data-mp="23jyetonljsj0">
          <span className="font-semibold text-primary flex items-center gap-2" data-id="element-128" data-mp="e2xg6y27te24">
            <Timer className="w-4 h-4" data-id="element-129" data-mp="94vx4d4sheqn" />
            Sprint · 1–2 Wochen
          </span>
          <span className="text-text-secondary" data-id="element-130" data-mp="3l3uuj85qk94q">{phaseLabels[phase]}</span>
        </div>
        <div className="h-2 rounded-full bg-bg-alt overflow-hidden" data-id="element-131" data-mp="3l21krjztt8si">
          <motion.div className="h-full bg-accent rounded-full" initial={false} animate={{
          width: `${phase / 3 * 100}%`
        }} transition={{
          duration: 0.4,
          ease: EASE_OUT
        }} data-id="element-132" data-mp="3p5zh5mxro5hv" />
        </div>
      </div>

      <LayoutGroup data-id="element-133" data-mp="7phpcl5ff7rm">
        <div className="flex-1 grid grid-cols-3 gap-3 min-h-0" data-id="element-134" data-mp="7nwv6wn0xqua">
          {columns.map((title, ci) => <div key={title} className={`rounded-2xl p-3 flex flex-col gap-2 ${ci === 2 ? 'bg-white ring-2 ring-accent' : 'bg-white/60'}`} data-id="element-135" data-mp="cmq6cieu95ra" data-mpi={ci}>
              <p className="text-xs font-semibold text-text-secondary mb-1" data-id="element-136" data-mp="lo7nm43zfdhk">
                {title}
              </p>
              {ci === column && cards.map((card, i) => <motion.div key={card} layoutId={`sprint-${card}`} transition={{
            layout: {
              duration: 0.45,
              ease: EASE_IN_OUT,
              delay: i * 0.06
            }
          }} className="bg-white rounded-lg shadow-sm border border-gray-100 px-2.5 py-2 flex items-center justify-between gap-2" data-id="element-137" data-mp="2ngma7ghh164b" data-mpi={i}>
                    <span className="text-[11px] xl:text-xs font-medium text-primary truncate" data-id="element-138" data-mp="3urab3g12ri30">
                      {card}
                    </span>
                    {ci === 2 && tested && <motion.span initial={{
              scale: 0.6,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              duration: 0.2,
              ease: EASE_OUT,
              delay: i * 0.08
            }} className="w-5 h-5 rounded-full bg-accent flex items-center justify-center shrink-0" data-id="element-139" data-mp="8l523168y5ua">
                        <Check className="w-3 h-3 text-primary" strokeWidth={3} data-id="element-140" data-mp="rd7j4dmsvo52" />
                      </motion.span>}
                  </motion.div>)}
              {ci === 2 && <div className={`mt-auto flex items-center gap-2 text-xs font-semibold transition-colors duration-200 ${phase >= 2 ? 'text-primary' : 'text-text-muted'}`} data-id="element-141" data-mp="1fvzw2hhctmdp">
                  <UserCheck className="w-4 h-4" data-id="element-142" data-mp="s6ncqosbbxxo" />
                  Sie testen
                </div>}
            </div>)}
        </div>
      </LayoutGroup>
    </div>;
}